import React from 'react';
import PropTypes from 'prop-types';

import { Row, Col } from 'antd';
import { useTranslation } from 'react-i18next';

import useDeviceData from './useDeviceData';
import styles from './DeviceData.module.less';

function DeviceData() {

  const { t } = useTranslation();
  const { infoDevice } = useDeviceData(); 

  return (
    <>
      <Row>

          <Col
            xs={{
              span: 24,
            }}
            sm={{
              span: 24,
            }}
            md={{
              span: 12,
            }}
            lg={{
              span: 12,
            }}
            xl={{
              span: 12,
            }}
          >
            <div className={styles.colDeviceData}>
              <p>
                <b>
                  {t('views.device_graphics.device_data.business')}
                </b>
              </p>
              <p>
                {infoDevice.business}
              </p>
            </div>
          </Col>

          <Col
            xs={{
              span: 24,
            }}
            sm={{
              span: 24,
            }}
            md={{
              span: 12,
            }}
            lg={{
              span: 12,
            }}
            xl={{
              span: 12,
            }}
          >
            <div className={styles.colDeviceData}>
              <p>
                <b>
                  {t('views.device_graphics.device_data.client')}
                </b>
              </p>
              <p>
                {infoDevice.client}
              </p>
            </div>
          </Col>

          <Col
            xs={{
              span: 24,
            }}
            sm={{
              span: 24,
            }}
            md={{
              span: 12,
            }}
            lg={{
              span: 12,
            }}
            xl={{
              span: 12,
            }}
          >
            <div className={styles.colDeviceData}>
              <p>
                <b>
                  MAC:
                </b>
              </p>
              <p>
                {infoDevice.mac}
              </p>
            </div>
          </Col>

          <Col
            xs={{
              span: 24,
            }}
            sm={{
              span: 24,
            }}
            md={{
              span: 12,
            }}
            lg={{
              span: 12,
            }}
            xl={{
              span: 12,
            }}
          >
            <div className={styles.colDeviceData}>
              <p>
                <b>
                  {t('views.device_graphics.device_data.device')}
                </b>
              </p>
              <p>
                {infoDevice.name}
              </p>
            </div>
          </Col>

          <Col
            xs={{
              span: 24,
            }}
            sm={{
              span: 24,
            }}
            md={{
              span: 12,
            }}
            lg={{
              span: 12,
            }}
            xl={{
              span: 12,
            }}
          >
            <div className={styles.colDeviceData}>
              <p>
                <b>
                  Gateway:
                </b>
              </p>
              <p>
                {infoDevice.gateway}
              </p>
            </div>
          </Col>

          <Col
            xs={{
              span: 24,
            }}
            sm={{
              span: 24,
            }}
            md={{
              span: 12,
            }}
            lg={{
              span: 12,
            }}
            xl={{
              span: 12,
            }}
          >
            <div className={styles.colDeviceData}>
              <p>
                <b>
                  Firmware:
                </b>
              </p>
              <p>
                {infoDevice.firmware}
              </p>
            </div>
          </Col>

          <Col
            xs={{
              span: 24,
            }}
            sm={{
              span: 24,
            }}
            md={{
              span: 12,
            }}
            lg={{
              span: 12,
            }}
            xl={{
              span: 12,
            }}
          >
            <div className={styles.colDeviceData}>
              <p>
                <b>
                  {t('tables.devices.columns.slvdl')}:
                </b>
              </p>
              <p>
                {infoDevice.slvId}
              </p>
            </div>
          </Col>

          <Col
            xs={{
              span: 24,
            }}
            sm={{
              span: 24,
            }}
            md={{
              span: 24,
            }}
            lg={{
              span: 24,
            }}
            xl={{
              span: 24,
            }}
          >
            <div className={styles.colDeviceData}>
              <p>
                <b>
                  {t('views.device_graphics.device_data.device_types')}
                </b>
              </p>
              <p>
                {infoDevice.device_types}
              </p>
            </div>
          </Col>

          </Row>
    </>
  );

}

DeviceData.propTypes = {
  // eslint-disable-next-line react/no-unused-prop-types
  className: PropTypes.string,
};

DeviceData.defaultProps = {
  className: null,
};

export default DeviceData;
